import { useState, useEffect, useRef } from 'react'
import { apiFetch } from '../utils/api'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://92.53.107.15'

const C = {
  bg:        '#05050d',
  surface:   'rgba(255,255,255,0.028)',
  surface2:  'rgba(255,255,255,0.04)',
  border:    'rgba(180,185,230,0.09)',
  borderHi:  'rgba(180,185,230,0.2)',
  accent:    '#b8bdd4',
  accentDim: 'rgba(180,185,230,0.12)',
  text:      '#dce0f0',
  textMuted: '#8890aa',
  silverHi:  '#dce0f0',
  silverLo:  '#8890aa',
  green:     '#4dc88a',
  orange:    '#e09858',
  red:       '#d45a5a',
  purple:    '#9b7fd4',
  yellow:    '#e0b84a',
  greenDim:  'rgba(77,200,138,0.12)',
  redDim:    'rgba(212,90,90,0.12)',
}
const font = {
  heading: "'Cormorant Garamond', serif",
  mono:    "'Space Mono', monospace",
  body:    "'Inter', sans-serif",
}

function timeAgo(dateStr) {
  const d = new Date(dateStr)
  const diff = Math.floor((Date.now() - d) / 1000)
  if (diff < 60) return 'только что'
  if (diff < 3600) return `${Math.floor(diff / 60)} мин назад`
  if (diff < 86400) return `${Math.floor(diff / 3600)} ч назад`
  return `${Math.floor(diff / 86400)} д назад`
}

function formatTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}

// ─── Telegram Logs ────────────────────────────────────────────────────────────

function TelegramLogs() {
  const [users, setUsers] = useState([])
  const [selectedId, setSelectedId] = useState(null)
  const [messages, setMessages] = useState([])
  const messagesEndRef = useRef(null)

  useEffect(() => {
    loadUsers()
    const iv = setInterval(loadUsers, 3000)
    return () => clearInterval(iv)
  }, [])

  useEffect(() => {
    if (!selectedId) return
    loadMessages(selectedId)
    const iv = setInterval(() => loadMessages(selectedId), 3000)
    return () => clearInterval(iv)
  }, [selectedId])

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  async function loadUsers() {
    try {
      const res = await fetch(`${BASE_URL}/api/bot/conversations`)
      const data = await res.json()
      if (Array.isArray(data)) setUsers(data)
    } catch {}
  }

  async function loadMessages(userId) {
    try {
      const res = await fetch(`${BASE_URL}/api/bot/conversations/${userId}`)
      const data = await res.json()
      if (Array.isArray(data)) setMessages(data)
    } catch {}
  }

  async function toggleBlock(userId) {
    try {
      await apiFetch(`/api/bot/block/${userId}`, { method: 'POST' })
      loadUsers()
    } catch {}
  }

  const selectedUser = users.find(u => u.telegram_user_id === selectedId)

  return (
    <div style={{ display: 'flex', gap: 16, height: 560 }}>
      {/* Users list */}
      <div style={{
        width: 240, flexShrink: 0,
        background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${C.border}`,
          fontFamily: font.heading, fontSize: 16, color: C.accent,
        }}>
          Telegram {users.length > 0 && (
            <span style={{ fontSize: 12, color: C.textMuted, fontFamily: font.body }}>
              ({users.length})
            </span>
          )}
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {users.length === 0 ? (
            <div style={{ padding: 20, color: C.textMuted, fontSize: 13, fontFamily: font.body, textAlign: 'center' }}>
              Пока никто не писал боту
            </div>
          ) : users.map(u => (
            <div
              key={u.telegram_user_id}
              onClick={() => setSelectedId(u.telegram_user_id)}
              style={{
                padding: '12px 16px', cursor: 'pointer',
                background: selectedId === u.telegram_user_id ? C.accentDim : 'transparent',
                borderLeft: `3px solid ${selectedId === u.telegram_user_id ? C.accent : 'transparent'}`,
                borderBottom: `1px solid ${C.border}`,
                opacity: u.is_blocked ? 0.5 : 1,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: font.body, fontSize: 13, color: C.text, fontWeight: 500 }}>
                  {u.telegram_name || 'Без имени'}
                </span>
                {u.is_blocked && (
                  <span style={{ fontSize: 10, color: C.red, background: 'rgba(224,90,90,0.15)', padding: '1px 5px', borderRadius: 4 }}>
                    блок
                  </span>
                )}
              </div>
              <div style={{ fontSize: 11, color: C.textMuted, fontFamily: font.body, marginTop: 2 }}>
                {timeAgo(u.last_seen)} · {u.message_count} сообщ.
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chat view */}
      <div style={{
        flex: 1, background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}>
        {!selectedId ? (
          <div style={{
            flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: C.textMuted, fontFamily: font.body, fontSize: 14,
          }}>
            Выбери диалог слева
          </div>
        ) : (
          <>
            <div style={{
              padding: '12px 20px', borderBottom: `1px solid ${C.border}`,
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div>
                <span style={{ fontFamily: font.body, fontSize: 14, color: C.text, fontWeight: 500 }}>
                  {selectedUser?.telegram_name || 'Без имени'}
                </span>
                {selectedUser?.telegram_username && (
                  <span style={{ fontSize: 12, color: C.textMuted, marginLeft: 8 }}>
                    @{selectedUser.telegram_username}
                  </span>
                )}
              </div>
              <button
                onClick={() => toggleBlock(selectedId)}
                style={{
                  padding: '4px 12px', borderRadius: 6, cursor: 'pointer',
                  fontFamily: font.body, fontSize: 12,
                  background: selectedUser?.is_blocked ? 'rgba(76,175,130,0.15)' : 'rgba(224,90,90,0.15)',
                  border: `1px solid ${selectedUser?.is_blocked ? C.green : C.red}`,
                  color: selectedUser?.is_blocked ? C.green : C.red,
                }}
              >
                {selectedUser?.is_blocked ? 'Разблокировать' : 'Заблокировать'}
              </button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {messages.map((m, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: m.message_role === 'bot' ? 'flex-end' : 'flex-start' }}>
                  <div style={{
                    maxWidth: '72%', padding: '8px 12px', borderRadius: 10,
                    background: m.message_role === 'bot' ? C.accentDim : C.bg,
                    border: `1px solid ${m.message_role === 'bot' ? C.accent + '44' : C.border}`,
                    fontFamily: font.body, fontSize: 13, color: C.text, lineHeight: 1.5,
                  }}>
                    {m.message_text}
                    <div style={{ fontSize: 10, color: C.textMuted, marginTop: 4, textAlign: 'right' }}>
                      {formatTime(m.created_at)}
                    </div>
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// ─── Web Logs ─────────────────────────────────────────────────────────────────

function WebLogs() {
  const [visitors, setVisitors] = useState([])
  const [selectedId, setSelectedId] = useState(null)
  const [messages, setMessages] = useState([])
  const endRef = useRef(null)

  useEffect(() => {
    loadVisitors()
    const iv = setInterval(loadVisitors, 5000)
    return () => clearInterval(iv)
  }, [])

  useEffect(() => {
    if (!selectedId) return
    loadMessages(selectedId)
    const iv = setInterval(() => loadMessages(selectedId), 5000)
    return () => clearInterval(iv)
  }, [selectedId])

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  async function loadVisitors() {
    try {
      const res = await fetch(`${BASE_URL}/api/bot/web-conversations`)
      const data = await res.json()
      if (Array.isArray(data)) setVisitors(data)
    } catch {}
  }

  async function loadMessages(visitorId) {
    try {
      const res = await fetch(`${BASE_URL}/api/bot/web-conversations/${encodeURIComponent(visitorId)}`)
      const data = await res.json()
      if (Array.isArray(data)) setMessages(data)
    } catch {}
  }

  function shortId(id = '') {
    return id.slice(0, 8) + '...'
  }

  return (
    <div style={{ display: 'flex', gap: 16, height: 560 }}>
      {/* Visitors list */}
      <div style={{
        width: 240, flexShrink: 0,
        background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${C.border}`,
          fontFamily: font.heading, fontSize: 16, color: C.accent,
        }}>
          Посетители {visitors.length > 0 && (
            <span style={{ fontSize: 12, color: C.textMuted, fontFamily: font.body }}>
              ({visitors.length})
            </span>
          )}
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {visitors.length === 0 ? (
            <div style={{ padding: 20, color: C.textMuted, fontSize: 13, fontFamily: font.body, textAlign: 'center' }}>
              Веб-посетителей пока нет
            </div>
          ) : visitors.map(v => (
            <div
              key={v.visitor_id}
              onClick={() => setSelectedId(v.visitor_id)}
              style={{
                padding: '12px 16px', cursor: 'pointer',
                background: selectedId === v.visitor_id ? C.accentDim : 'transparent',
                borderLeft: `3px solid ${selectedId === v.visitor_id ? C.accent : 'transparent'}`,
                borderBottom: `1px solid ${C.border}`,
              }}
            >
              <div style={{ fontFamily: font.body, fontSize: 13, color: C.text, fontWeight: 500 }}>
                Посетитель {shortId(v.visitor_id)}
              </div>
              <div style={{ fontSize: 11, color: C.textMuted, fontFamily: font.body, marginTop: 2 }}>
                {timeAgo(v.last_seen)} · {v.message_count} сообщ.
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chat view */}
      <div style={{
        flex: 1, background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}>
        {!selectedId ? (
          <div style={{
            flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: C.textMuted, fontFamily: font.body, fontSize: 14,
          }}>
            Выберите посетителя слева
          </div>
        ) : (
          <>
            <div style={{
              padding: '12px 20px', borderBottom: `1px solid ${C.border}`,
              fontFamily: font.body, fontSize: 13, color: C.textMuted,
            }}>
              ID: <span style={{ color: C.text, fontFamily: 'monospace', fontSize: 11 }}>{selectedId}</span>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {messages.map((m, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: m.role === 'assistant' ? 'flex-end' : 'flex-start' }}>
                  <div style={{
                    maxWidth: '72%', padding: '8px 12px', borderRadius: 10,
                    background: m.role === 'assistant' ? C.accentDim : C.bg,
                    border: `1px solid ${m.role === 'assistant' ? C.accent + '44' : C.border}`,
                    fontFamily: font.body, fontSize: 13, color: C.text, lineHeight: 1.5,
                  }}>
                    {m.message}
                    <div style={{ fontSize: 10, color: C.textMuted, marginTop: 4, textAlign: 'right' }}>
                      {m.role === 'assistant' ? '← двойник' : 'посетитель →'} · {formatTime(m.created_at)}
                    </div>
                  </div>
                </div>
              ))}
              <div ref={endRef} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// ─── BotLogs (main export) ────────────────────────────────────────────────────

export default function BotLogs() {
  const [source, setSource] = useState('telegram')

  const tabStyle = (active) => ({
    padding: '7px 20px', borderRadius: 20, cursor: 'pointer',
    fontFamily: font.body, fontSize: 13,
    background: active ? C.accentDim : 'transparent',
    border: `1px solid ${active ? C.accent : C.border}`,
    color: active ? C.accent : C.textMuted,
  })

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button style={tabStyle(source === 'telegram')} onClick={() => setSource('telegram')}>
          Telegram-бот
        </button>
        <button style={tabStyle(source === 'web')} onClick={() => setSource('web')}>
          Веб-чат
        </button>
      </div>
      {source === 'telegram' ? <TelegramLogs /> : <WebLogs />}
    </div>
  )
}
